import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

type SafariWarningDialogProps = {
  isOpen: boolean;
  close: () => void;
};
export function SafariWarningDialog({ isOpen, close }: SafariWarningDialogProps) {
  return (
    <Dialog open={isOpen} onClose={close} aria-describedby="alert-dialog-description">
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component={"div"}>
          Looks like you are trying to open this game table in Safari. This might result in poor performance. Please use
          a different browser to avoid technical difficulties.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            localStorage.setItem("hide-safari-warning", "true");
            close();
          }}
        >
          Don't show me again
        </Button>
        <Button onClick={close} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
